import { combineReducers } from '@reduxjs/toolkit';
import smc from 'surface_mount_carriers/store/slice';

const rootReducer = combineReducers({
  smc,
});

export default rootReducer;
